import React, {useState, useEffect} from 'react'
import { useSelector } from 'react-redux';
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import EditModal from '../components/profilePage/EditModal'
import EditUsernameForm from '../components/profilePage/forms/Account/EditUsernameForm'
import EditEmailForm from '../components/profilePage/forms/Account/EditEmailForm'
import EditPasswordForm from '../components/profilePage/forms/Account/EditPasswordForm'
import EditSubscriptionForm from '../components/profilePage/forms/Subscription/EditSubscriptionForm'
import ViewInvoices from '../components/profilePage/forms/Subscription/ViewInvoices'
import InvoiceDetails from '../components/profilePage/forms/Subscription/InvoiceDetails'
import ViewPaymentMethod from '../components/profilePage/forms/Subscription/ViewPaymentMethod'
import UpdatePaymentMethod from '../components/profilePage/forms/Subscription/UpdatePaymentMethod'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import '../styles/profilepage.css'; // Import your CSS file
import ConfirmVerificationCode from '../components/profilePage/forms/Account/ConfirmVerificationCode'
import ToastNotification from '../components/ToastNotification'; // Import the ToastNotification component
import VerifyUserWithPassword from '../components/profilePage/VerifyUserWithPassword'
import ProfileLoader from '../components/loaders/ProfileLoader';
import AccountInfo from '../components/profilePage/forms/Account/AccountInfo'
import SubscriptionInfo from '../components/profilePage/forms/Subscription/SubscriptionInfo'
import { useNavigate } from 'react-router-dom';
import DeviceInfo from '../components/profilePage/forms/Devices/DeviceInfo'
import DeleteDeviceDetails from '../components/profilePage/forms/Devices/DeleteDeviceDetails'
import { checkSession } from '../auth/authService'

const mockUserData = {
  id: "ayuoiyd8w92298983",
  username: "", // FoxMccloud
  email: "", //foxmcloud@starfox.com
  subscription: "Guest",
  email_verified: false,
};

const ProfilePage = () => {

  const [userData, setUserData] = useState(mockUserData);
  const [userSubscriptionData, setUserSubscriptionData] = useState(null);
  const [userInvoiceData, setUserInvoiceData] = useState(null);
  const [serverMessage, setServerMessage] = useState(null);
  const [modalHistory, setModalHistory] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [proceed, setProceed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [deviceData, setDeviceData] = useState(null);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const isLoggedIn = useSelector((state) => state.account.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn === false) {
      localStorage.removeItem('session_active');
      localStorage.removeItem('username');
      localStorage.removeItem('contributorType');
      navigate("/login");
    }
  }, [isLoggedIn]);

  const getUserData = async () => {
    const response = await fetch(`${apiUrl}/user/getuser`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    });


    const userData = await response.json();

    if(userData.success === true) {
      setUserData(userData.data);
    }
  };

    const getUserSubscriptionData = async () => {
      try {
          const response = await fetch(`${apiUrl}/subscription/existing-subscription`, {
              method: "GET",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
          });
          const data = await response.json();

          if (data.success && data.subscription) {
              setUserSubscriptionData(data.subscription);
              setDeviceData(data.subscription.deviceTracking);
          }

      } catch (error) {
          console.error("Error fetching subscription data:", error);
          alert("There was an error fetching your subscription data. Please try again.");
          // navigate("/");
      }
  }

  const getUserInvoices = async () => {
    const response = await fetch(`${apiUrl}/subscription/invoices`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    });

    const invoiceData = await response.json();

    if(invoiceData.success === true) {
      setUserInvoiceData(invoiceData.data.Items);
    } else {
      setServerMessage(invoiceData);
    }
  }

  const refreshCookies = async () => {
    const response = await fetch(`${apiUrl}/auth/refresh`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    });

    const data = await response.json();

    if(data.success !== true) {
      setServerMessage(data.message);
    }
  };

  const initialLoad = async () => {
    const isSessionActive = await checkSession();
    if (!isSessionActive) {
      navigate("/login");
      return;
    }
    await getUserData();
    await getUserSubscriptionData();
    await getUserInvoices();
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    initialLoad();
  }, []);

  const openModal = (modalName, requiresPassword = false) => {
    setModalHistory((prevHistory) => {
      const updatedHistory = [...prevHistory];
      // If the user validates their password once then they can access other modals requiring password without validating again
      // If the user's email is not verified yet then they shouldn't require password validation yet. Otherwise, they'd get locked out of their account. Especially if suddenly they need to change their password because they forgot it.
      if (requiresPassword && proceed === false && userData.email_verified) {
        updatedHistory.push(modalName); // Add the intended modal first
        updatedHistory.push('passwordVerification'); // Add passwordVerification last
      } else {
        updatedHistory.push(modalName); // Add the intended modal only
      }
      return updatedHistory;
    });
  };

  const returnModal = () => {
    setModalHistory((prevHistory) => prevHistory.slice(0, -1));
  };

  const closeModal = () => {
    setModalHistory([]);
  };

  const convertFromSecondToLowercase = (str) => {
      if (str.length < 2) return str; // If the string is too short, return it as is

      return str[0] + str.slice(1).toLowerCase(); // Keep the first character as is, and lowercase the rest
  };

  const currentModal = modalHistory[modalHistory.length - 1];

  return (
    <div className="wrapper">
          <div id="content-wrap">
              <Navbar />  
              <div> 
                {isLoading ? (
                  <ProfileLoader />
                ) : (
                  <div className='d-flex flex-column justify-content-center align-items-center mt-5' style={{minHeight: "80vh"}}>
                    <h2>Account</h2>
                    <AccountInfo 
                      userData={userData} 
                      openModal={openModal}
                    />
                    <SubscriptionInfo 
                      userSubscriptionData={userSubscriptionData} 
                      openModal={openModal} 
                      convertFromSecondToLowercase={convertFromSecondToLowercase}
                    />
                    <DeviceInfo 
                      deviceData={deviceData}
                      openModal={openModal} 
                    />
                  </div>
                )}

              </div>
            </div>
            <Footer />

            {/* Rendering modals dynamically */}
            {currentModal && (
              <EditModal onClose={closeModal} onBack={currentModal !== 'passwordVerification' ? returnModal : null} showBackButton={currentModal !== 'passwordVerification' && modalHistory.length > 1}>
                {currentModal === 'username' && <EditUsernameForm openModal={openModal} closeModal={closeModal} refreshData={getUserData} refreshCookies={refreshCookies} setServerMessage={setServerMessage} userEmail={userData.email}/>}
                {currentModal === 'passwordVerification' && (
                  <VerifyUserWithPassword 
                    closeModal={closeModal}
                    setProceed={setProceed}
                    setServerMessage={setServerMessage} 
                    modalHistory={modalHistory}
                    setModalHistory={setModalHistory} // Pass down the setModalHistory function
                  />
                )}
                {currentModal === 'editEmail' && (
                  <EditEmailForm 
                    closeModal={closeModal} 
                    setVerificationEmail={setModalData} 
                    currentEmail={userData.email} 
                    setServerMessage={setServerMessage} 
                    proceed={proceed}
                    emailVerified={userData.email_verified}
                  />
                )}
                {currentModal === 'confirmVerification' && <ConfirmVerificationCode closeModal={closeModal} setVerificationEmail={setModalData} verificationEmail={modalData} currentEmail={userData.email} status={userData.email_verified} setServerMessage={setServerMessage} refreshCookies={refreshCookies}/>}
                {currentModal === 'password' && <EditPasswordForm openModal={openModal} closeModal={closeModal} refreshData={getUserData} refreshCookies={refreshCookies} setServerMessage={setServerMessage} userEmail={userData.email}/>}
                {currentModal === 'subscription' && <EditSubscriptionForm openModal={openModal} userData={userData} lastInvoiceData={userInvoiceData[0]}/>}
                {currentModal === 'invoices' && <ViewInvoices openModal={openModal} setInvoiceData={setModalData} userInvoiceData={userInvoiceData}/>}
                {currentModal === 'invoiceDetails' && <InvoiceDetails openModal={openModal} invoiceData={modalData}/>}
                {currentModal === 'paymentMethod' && <ViewPaymentMethod openModal={openModal}/>}
                {currentModal === 'deleteDeviceA' && <DeleteDeviceDetails device="A" deviceData={deviceData} onClose={closeModal} setDeviceData={setDeviceData} setServerMessage={setServerMessage} />}
                {currentModal === 'deleteDeviceB' && <DeleteDeviceDetails device="B" deviceData={deviceData} onClose={closeModal} setDeviceData={setDeviceData} setServerMessage={setServerMessage} />}
              </EditModal>
            )}

            {/* Toast Notification */}
            <ToastNotification
              message={serverMessage} 
              setServerMessage={() => setServerMessage(null)} // Clear the message after displaying it
            />
        </div>
  )
}

export default ProfilePage;